var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('new-cv-popup', {
    attrs: {
      "data-to-show": _vm.stepNewCvPopupDisplayed,
      "errors": _vm.errorsCreateNewCv
    },
    on: {
      "close": function ($event) {
        return _vm.displayPopupNewCV(-1);
      },
      "createNewCv": function (infos) {
        _vm.newCV(infos);
      },
      "changePage": function (step) {
        return _vm.stepNewCvPopupDisplayed = step;
      }
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "lg:mx-52 text-gray-600"
  }, [_vm._v("\n    Votre espace CV est vierge.\n  ")]), _vm._v(" "), _c('h6', {
    staticClass: "lg:mx-52 text-gray-600 mt-5"
  }, [_vm._v("\n    Pour créer votre premier CV, cliquer sur le bouton \"Créer mon premier CV\"\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mt-15"
  }, [_c('action-button', {
    attrs: {
      "id": "create-cv",
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "Créer mon premier CV",
      "uppercase": true,
      "icon": "plus-circle",
      "type-shadow": "indigo-shadow"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.displayPopupNewCV(1);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mt-10"
  }, [_c('illustration', {
    attrs: {
      "name": "evaluation"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }